// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_Mm0","content":"styles_content__3x02q","tableWrap":"styles_tableWrap__2S4qG"};